import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CircularProgress, Grid, Typography } from '@mui/material';
import { INGESTION_STATUS } from '../../services/config/ApiConstants';
import Gantt from './Gantt/Gantt';
import { useGanttWizard } from './GanttWizardHook';
import { OpenWizardButton } from './Wizard/OpenWizardButton';
import Wizard from './Wizard/Wizard';

const WizardAndGantt = () => {
  const { t } = useTranslation();
  const { status, datasetId, doesDatasetExist, isDatasetTwingraph, datasetIngestionStatus } = useGanttWizard();
  const [isWizardOpen, setIsWizardOpen] = useState(false);
  const [selectedGisement, setSelectedGisement] = useState(null);
  const [selectedPolicy, setSelectedPolicy] = useState(null);
  const [activeTab, setActiveTab] = useState(1);
  const [initialStep, setInitialStep] = useState(0);

  const handleOpenWizard = (gisement, policyId) => {
    const gisementNameWithoutAssetClass = gisement?.split('(')[0]?.trim();
    setSelectedGisement(gisementNameWithoutAssetClass);
    setSelectedPolicy(policyId);
    setActiveTab(1);
    setInitialStep(1);
    setIsWizardOpen(true);
  };

  const handleCloseWizard = (event, reason) => {
    if (reason === 'backdropClick') return;
    setIsWizardOpen(false);
    setSelectedGisement('');
    setSelectedPolicy('');
    setActiveTab(0);
    setInitialStep(0);
  };

  if (!datasetId)
    return (
      <Grid container sx={{ justifyContent: 'center', alignItems: 'center' }}>
        <Typography>
          {t(
            'commoncomponents.equipment.datasetErrors.noDatasetAssociated',
            'No dataset is associated with the chosen scenario'
          )}
        </Typography>
      </Grid>
    );
  if (!doesDatasetExist)
    return (
      <Grid container sx={{ justifyContent: 'center', alignItems: 'center' }}>
        <Typography>
          {t(
            'commoncomponents.equipment.datasetErrors.datasetNotFound',
            'The dataset associated with the scenario could not be found'
          )}
        </Typography>
      </Grid>
    );
  if (!isDatasetTwingraph)
    return (
      <Grid container sx={{ justifyContent: 'center', alignItems: 'center' }}>
        <Typography>
          {t(
            'commoncomponents.equipment.datasetErrors.datasetNotTwingraph',
            'The dataset associated with the scenario is not of type twingraph'
          )}
        </Typography>
      </Grid>
    );
  if (datasetIngestionStatus !== INGESTION_STATUS.SUCCESS)
    return (
      <Grid container sx={{ justifyContent: 'center', alignItems: 'center' }}>
        <Typography>
          {t(
            'commoncomponents.equipment.datasetErrors.datasetNotReady',
            'The dataset associated with the scenario is not ready, its status is {{status}}',
            { status: datasetIngestionStatus }
          )}
        </Typography>
      </Grid>
    );
  if (status === 'LOADING') return <CircularProgress data-cy="gantt-queries-loading-spinner" />;
  return (
    <div>
      <OpenWizardButton onOpenWizard={() => setIsWizardOpen(true)} />
      <Gantt onPolicyLabelClick={handleOpenWizard} />
      {isWizardOpen && (
        <Wizard
          isWizardOpen={isWizardOpen}
          handleCloseWizard={handleCloseWizard}
          {...(selectedGisement && selectedPolicy
            ? {
                selectedGisement,
                selectedPolicy,
                activeTab,
                initialStep,
              }
            : {})}
        />
      )}
    </div>
  );
};

export default WizardAndGantt;
